export const TRANSPARENCIA_REQUEST = "TRANSPARENCIA_REQUEST";
export const TRANSPARENCIA_SUCCESS = "TRANSPARENCIA_SUCCESS";
export const TRANSPARENCIA_FAIL = "TRANSPARENCIA_FAIL";
